import React, { FC } from 'react';
import Section from '../../../Components/Section/Section';
import Container from '../../../../../Common/Container/Container';
import SectionTitle from '../../../../../Common/SectionTitle/SectionTitle';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import MapWrapper from '../../../../../Common/MapWrapper';
import markerIcon from '../../../../../../assets/icons/point-green.svg';
import primaryMarkerIcon from '../../../../../../assets/icons/point-dark-blue.svg';
import * as classes from './LocationsSection.module.scss';
import AppointmentTypesList from '../../../Components/ServiceInfo/AppointmentTypesList/AppointmentTypesList';
import MapLegend from '../../../Components/MapLegend/MapLegend';
import { ServiceLocationsSectionProps } from '../../../../../Sections/Services/LocationsSection/LocationsSection';

const LocationsSection: FC<ServiceLocationsSectionProps> = ({
  serviceName,
  serviceId,
  otherLocations,
  primaryLocation,
  mobilityRadius,
  appointmentTypes,
  phoneNumber,
}) => {
  const { t } = useTranslation();
  const mapLegend = <MapLegend primaryLocationMarkerIcon={primaryMarkerIcon} otherLocationsMarkerIcon={markerIcon} />;

  return (
    <Section number={'02'} label={t('services.locationsSection.sectionTitle')}>
      <Container className={classes.wrapper}>
        <div className='row'>
          <div className='col-xl-5 col-lg-5 col-md-12'>
            <div className={classes.infoWrapper}>
              <SectionTitle>{`${t('services.locationsSection.titleText')}`}</SectionTitle>
              <div className={classes.appointmentsTypesWrapper}>
                <AppointmentTypesList items={appointmentTypes} bordered />
              </div>
            </div>
          </div>
          <div className='col-xl-7 col-lg-7 col-md-12 col-sm-12'>
            <MapWrapper
              phoneNumber={phoneNumber}
              serviceId={serviceId}
              mobilityRadius={mobilityRadius}
              otherLocations={otherLocations}
              primaryLocation={primaryLocation}
              otherLocationsMarkerIcon={markerIcon}
              primaryLocationMarkerIcon={primaryMarkerIcon}
              legendComponent={mapLegend}
            />
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default LocationsSection;
